import {COLOR} from '@app/@core/colors';
import {CouponStatus, DiscountType} from '@app/models/v3/coupon';

export function couponStatusColor(status: CouponStatus): COLOR {
    switch (status) {
        case CouponStatus.ACTIVE:
            return 'green';
        case CouponStatus.INACTIVE:
            return 'red';
        case CouponStatus.EXPIRED:
            return 'bluegray';
        case CouponStatus.USED_UP:
            return 'orange';
        case CouponStatus.PENDING:
            return 'blue';
    }
}

export function discountTypeColor(discountType: DiscountType): COLOR {
    switch (discountType) {
        case DiscountType.FIXED:
            return 'purple';
        case DiscountType.SERVICE:
            return 'blue';
    }
}
